/* eslint-env browser */

/**
 * Homepage category filter
 *
 * The chips rendered by partials/category-filter.hbs stay real links to the tag
 * archives so the nav still works without JS, but on the homepage a click
 * filters the feed in place instead of navigating away. Only the tag links on a
 * post card take you to the archive.
 *
 * Matching is done against the `data-tags` attribute on each card, so a post is
 * found under every one of its tags, not just the primary one.
 *
 * The feed is paginated, so filtering first pulls in the remaining pages
 * through window.casperFeed (infinite-scroll.js) - a tag whose posts live on
 * page 2 would otherwise come up empty. Cards appear as each page lands rather
 * than after the last one.
 *
 * The active tag is kept in the URL (?tag=slug) so the view survives a reload
 * and the back button steps through the filters.
 */

(function (window, document) {
    var nav = document.querySelector('[data-category-filter]');
    var feed = document.querySelector('.post-feed');

    if (!nav || !feed) {
        return;
    }

    var buttons = nav.querySelectorAll('.category-filter-btn');

    // The divider and the "Latest Articles" heading split the featured first
    // card from the rest of the feed - meaningless once the feed is filtered.
    var dividers = feed.querySelectorAll('.post-divider-wrapper, .latest-articles-heading-wrapper');

    var activeSlug = '';
    var emptyElement = null;

    function slugFromUrl() {
        return new window.URLSearchParams(window.location.search).get('tag') || '';
    }

    function matches(card) {
        if (!activeSlug) {
            return true;
        }

        return (card.getAttribute('data-tags') || '').split(' ').indexOf(activeSlug) !== -1;
    }

    // Applies the current filter to whatever is in the feed right now and
    // returns how many cards are left visible.
    function render() {
        var visible = 0;

        feed.querySelectorAll('.post-card').forEach(function (card) {
            var isMatch = matches(card);
            card.classList.toggle('is-filtered-out', !isMatch);
            if (isMatch) {
                visible += 1;
            }
        });

        dividers.forEach(function (divider) {
            divider.classList.toggle('is-filtered-out', Boolean(activeSlug));
        });

        feed.classList.toggle('is-filtered', Boolean(activeSlug));

        buttons.forEach(function (button) {
            button.classList.toggle('active', (button.getAttribute('data-slug') || '') === activeSlug);
        });

        return visible;
    }

    function setEmpty(isEmpty) {
        if (isEmpty && !emptyElement) {
            emptyElement = document.createElement('p');
            emptyElement.className = 'category-filter-empty';
            emptyElement.textContent = 'No posts in this category yet.';
            feed.parentNode.insertBefore(emptyElement, feed.nextSibling);
            return;
        }

        if (!isEmpty && emptyElement) {
            emptyElement.remove();
            emptyElement = null;
        }
    }

    function apply(slug) {
        activeSlug = slug;

        var visible = render();
        var loader = window.casperFeed;

        if (slug && loader && loader.hasMore()) {
            // render() runs again for every page that arrives, through onCards
            nav.classList.add('is-loading');
            setEmpty(false);

            loader.loadAll().then(function () {
                nav.classList.remove('is-loading');
                setEmpty(render() === 0);
            });

            return;
        }

        setEmpty(Boolean(slug) && visible === 0);
    }

    nav.addEventListener('click', function (event) {
        var button = event.target.closest('.category-filter-btn');

        if (!button) {
            return;
        }

        // leave modified clicks alone - they should open the tag archive
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();

        var slug = button.getAttribute('data-slug') || '';

        if (slug === activeSlug) {
            return;
        }

        apply(slug);
        window.history.pushState({tag: slug}, '', slug ? '?tag=' + encodeURIComponent(slug) : window.location.pathname);
    });

    window.addEventListener('popstate', function () {
        apply(slugFromUrl());
    });

    function init() {
        // infinite scroll keeps appending during normal browsing too, so any
        // active filter has to be applied to the new cards
        if (window.casperFeed) {
            window.casperFeed.onCards(function () {
                if (activeSlug) {
                    render();
                }
            });
        }

        var slug = slugFromUrl();

        if (slug) {
            apply(slug);
        }
    }

    // deferred scripts run before DOMContentLoaded, and this file is
    // concatenated ahead of infinite-scroll.js - wait for window.casperFeed
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})(window, document);
